import { render, staticRenderFns } from "./CardListFullImage.vue?vue&type=template&id=c868a854&scoped=true"
import script from "./CardListFullImage.vue?vue&type=script&lang=js"
export * from "./CardListFullImage.vue?vue&type=script&lang=js"
import style0 from "./CardListFullImage.vue?vue&type=style&index=0&id=c868a854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c868a854",
  null
  
)

export default component.exports